export default "__VITE_ASSET__0fa329e1__"